import classNames from "classnames";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import styles from "../style.module.scss";
import { useSelector } from "react-redux";
import { roundNum } from "shared/utils/helper";

interface navItemInterface extends SideBarItemPathType {
  setIsOpen: (val: boolean) => void;
  isBlank?: boolean;
}

const NavItem = ({
  title,
  Icon,
  path,
  subPaths,
  isBlank,
  setIsOpen,
}: navItemInterface) => {
  const {
    theme: { theme },
    archive: { count },
    breadcrumb: { prePath },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (
      (location.pathname === routeConstant.evaluationRecord.path ||
        location.pathname === routeConstant.archiveEvaluationRecord.path) &&
      subPaths
    ) {
      setActive(true);
    } else if (path === location.pathname) {
      setActive(true);
    } else if (
      location.pathname ===
      routeConstant.evaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (
        (prePath === routeConstant.evaluationRecord.path ||
          prePath === routeConstant.archiveEvaluationRecord.path) &&
        subPaths
      ) {
        setActive(true);
      } else if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.cgpEvaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else if (
      location.pathname ===
      routeConstant.continueDraftEvaluation.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === path) {
        setActive(true);
      } else {
        setActive(false);
      }
    } else {
      setActive(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <Link
        className={classNames(
          theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
          active ? styles.activeNavItemContainer : styles.navItemContainer,
          "w-full"
        )}
        target={isBlank ? "_blank" : ""}
        to={path ? path : ""}
        onClick={() => {
          setIsOpen(false);
        }}
      >
        {Icon ? (
          <img src={Icon} alt="" className={classNames(styles.icon)} />
        ) : null}

        <label className={classNames(styles.heading)} role="button">
          {title}
        </label>
        {title === routeConstant.draftEvaluation.title &&
          count?.draftCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.draftCount), 1)}
            </div>
          )}
        {title === routeConstant.flagEvaluation.title &&
          count?.flaggedCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.flaggedCount), 1)}
            </div>
          )}
        {title === routeConstant.cgpEvaluation.title && count?.cgpCount > 0 && (
          <div className={classNames(styles.badge)}>
            {roundNum(String(count?.cgpCount), 1)}
          </div>
        )}
      </Link>
      <div
        className={classNames(styles.subPathsList, "w-full justify-between")}
      >
        {subPaths?.map((subPath: SideBarItemPathType, index: number) => {
          return (
            <SubPath
              key={index}
              subPath={subPath}
              count={count}
              setIsOpen={setIsOpen}
            />
          );
        })}
      </div>
    </>
  );
};

const SubPath = ({ subPath, count, setIsOpen }: any) => {
  const {
    theme: { theme },
    breadcrumb: { prePath },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const [isActivePath, setIsActivePath] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname === subPath?.path) {
      setIsActivePath(true);
    } else if (
      location.pathname ===
      routeConstant.evaluationRecordDetail.path.replace(
        ":id",
        location.pathname.split("/")?.[3]
      )
    ) {
      if (prePath === subPath?.path) {
        setIsActivePath(true);
      } else {
        setIsActivePath(false);
      }
    } else {
      setIsActivePath(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);
  return (
    <Link
      to={subPath.path ? subPath.path : ""}
      className={classNames(
        theme === "dark" ? styles.darkNavIcon : styles.lightNavIcon,
        isActivePath
          ? styles.activeSubNavItemContainer
          : styles.navItemContainer,
        "w-full pr-3 justify-between"
      )}
      onClick={() => {
        setIsOpen(false);
      }}
    >
      <div className={classNames("flex items-center", styles.subPathContainer)}>
        <img src={subPath.Icon} alt="" className={classNames(styles.icon)} />
        <label className={classNames(styles.heading)} role="button">
          {subPath.title}
        </label>
        {subPath.title === routeConstant.evaluationRecord.title &&
          count?.totalCount > 0 && (
            <div className={classNames(styles.badge)}>
              {roundNum(String(count?.totalCount), 1)}
            </div>
          )}
      </div>
    </Link>
  );
};

export default NavItem;
